"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERVIEW_PREPARATION_CONFIG_FIELDS = exports.ENTITY_SHEET_CONFIG_FIELDS = exports.OPPORTUNITY_CONFIG_FIELDS = exports.AI_CONFIG_VARIANTS = exports.DT_CONFIG_FIELDS = void 0;
exports.buildDtFieldConfigType = buildDtFieldConfigType;
exports.buildOpportunityFieldConfigType = buildOpportunityFieldConfigType;
exports.buildEntitySheetFieldConfigType = buildEntitySheetFieldConfigType;
exports.buildInterviewPreparationFieldConfigType = buildInterviewPreparationFieldConfigType;
const catalog_1 = require("./catalog");
exports.DT_CONFIG_FIELDS = [
    'experience',
    'skills',
    'training',
    'languages',
    'activityAreas',
    'expertiseAreas',
    'tools',
    'references',
    'references-identity',
    'references-content',
    'references-splitter',
    'references-dispatcher',
    'references-identity-academic-personal',
    'references-content-academic-personal',
];
exports.AI_CONFIG_VARIANTS = ['basic', 'advanced', 'mini'];
exports.OPPORTUNITY_CONFIG_FIELDS = ['tools', 'activityAreas', 'expertiseArea', 'place'];
exports.ENTITY_SHEET_CONFIG_FIELDS = ['informations-civility'];
exports.INTERVIEW_PREPARATION_CONFIG_FIELDS = ['activityAreas', 'commutingTimeRating'];
function ensureCatalogType(candidate) {
    (0, catalog_1.assertAiConfigType)(candidate);
    return candidate;
}
function buildDtFieldConfigType(field, variant) {
    return ensureCatalogType(`enrich-dt-field-${field}${variant ? `-${variant}` : ''}`);
}
function buildOpportunityFieldConfigType(field) {
    return ensureCatalogType(`enrich-opportunity-field-${field}`);
}
function buildEntitySheetFieldConfigType(field) {
    return ensureCatalogType(`enrich-entity-sheet-field-${field}`);
}
function buildInterviewPreparationFieldConfigType(field) {
    return ensureCatalogType(`interview-preparation-field-${field}`);
}
